import React, { SyntheticEvent } from 'react'
import { useState } from 'react'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { Box, Tab } from '@mui/material'
import InfoBlock from '../../components/InfoBlock'
import { PRTable, PRTableProps } from './PRTable'
import { PRInputListItem } from '@finance-lab/utils/types'
import { CompanyEntity } from 'types/CompanyEntity'

export const PRTabs = ({
    prsInInbox,
    prsArchived,
    setPrsInInbox,
    setPrsArchived,
    setSelectedCompany,
    selectedPR,
    setSelectedPR,
    onArchive,
    onUnarchive,
    ...prTableProps
}: {
    prsInInbox: PRInputListItem[] | null
    prsArchived: PRInputListItem[] | null
    setPrsInInbox: (prs: PRInputListItem[]) => void
    setPrsArchived: (prs: PRInputListItem[]) => void
    setSelectedCompany: (c: Pick<CompanyEntity, 'id' | 'name'>) => void
    selectedPR: PRInputListItem | null
    setSelectedPR: (pr: PRInputListItem | null) => void
} & Omit<PRTableProps, 'onBlock' | 'prs'>) => {
    const [selectedTab, setSelectedTab] = useState<'inbox' | 'archived'>('inbox')
    const handleChange = (event: SyntheticEvent, newValue: 'inbox' | 'archived') => setSelectedTab(newValue)

    return (
        <InfoBlock title='Pressmeddelanden' loadingElement={!prsInInbox && !prsArchived}>
            <TabContext value={selectedTab}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange}>
                        <Tab label='Inbox' value='inbox' />
                        <Tab label='Arkiverade' value='archived' />
                    </TabList>
                </Box>
                <TabPanel value='inbox'>
                    <PRTable
                        prs={prsInInbox}
                        onArchive={onArchive}
                        {...prTableProps}
                        setSelectedCompany={setSelectedCompany}
                        selectedPR={selectedPR}
                        setSelectedPR={setSelectedPR}
                    />
                </TabPanel>
                <TabPanel value='archived'>
                    <PRTable prs={prsArchived} onUnarchive={onUnarchive} {...prTableProps} />
                </TabPanel>
            </TabContext>
        </InfoBlock>
    )
}
